import { UnreadIndicator } from "@circle-react-shared/UnreadIndicator";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

import type { FloatingWidgetButtonProps } from "./types";
import { WidgetToggleButton } from "./WidgetToggleButton";

const buildButtonLabel = (label: string, unreadCount: number) =>
  unreadCount > 0
    ? t("floating_widget_button.unread_label", {
        name: label,
        count: unreadCount,
      })
    : label;

export const FloatingWidgetButton = ({
  expanded,
  onClick,
  onToggle,
  label,
  leading,
  unreadCount = 0,
}: FloatingWidgetButtonProps) => (
  <div className="animate-fade-in-slow border-primary bg-primary shadow-2xs hover:border-hover hover:bg-hover inline-flex max-w-[min(280px,calc(100vw-40px))] items-center rounded-full border p-1 opacity-0 transition-[background-color,border-color,box-shadow] duration-200 hover:shadow-none motion-reduce:animate-none motion-reduce:opacity-100 motion-reduce:transition-none">
    <button
      type="button"
      onClick={onClick}
      aria-label={buildButtonLabel(label, unreadCount)}
      className="flex min-w-0 items-center rounded-full focus-visible:outline-none"
    >
      <span className="relative flex shrink-0">
        {leading}
        {unreadCount > 0 && (
          <span className="absolute -top-1 left-full -ml-3">
            <UnreadIndicator count={unreadCount} />
          </span>
        )}
      </span>
      <div
        className={classNames(
          "grid min-w-0 transition-[grid-template-columns,opacity] duration-200 motion-reduce:transition-none",
          {
            "grid-cols-[1fr] opacity-100": expanded,
            "grid-cols-[0fr] opacity-0": !expanded,
          },
        )}
      >
        <div className="min-w-0 overflow-hidden">
          <div className="pl-2">
            <Typography variant="label-sm" color="primary" truncate>
              {label}
            </Typography>
          </div>
        </div>
      </div>
    </button>
    {onToggle && <WidgetToggleButton expanded={expanded} onClick={onToggle} />}
  </div>
);
